import type SavedLocation from "./savedLocation";

/**
 * Whether the given user can edit this location, based on its visibility:
 * a fleet-visible location requires the `location-management` capability,
 * a private location can only be edited by the user who created it.
 *
 * Shared by LocationDetails.vue's own edit toggle and
 * LocationDisplayCard.vue's list-level edit button, so the same rule
 * decides whether an edit affordance is shown everywhere one could be.
 */
export function canEditLocation(
  location: SavedLocation,
  {
    canManageFleetLocations,
    currentUserId,
  }: {
    canManageFleetLocations: boolean;
    currentUserId: string | undefined;
  },
): boolean {
  if (location.visibility === "fleet") return canManageFleetLocations;

  if (location.visibility === "private") {
    return location.user_created_directus_id === currentUserId;
  }

  return false;
}
